import React, {useEffect, useState} from "react";
import TextField from "@material-ui/core/TextField";
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";


const useStyles = makeStyles({
    root: {
        fontSize: 10,
    }
});

export default function MaxOptionPriceTextField({maxOptionPrice, setMaxOptionPrice}) {
    const classes = useStyles();
    const [inputValue, setInputValue] = useState(maxOptionPrice !== null ? maxOptionPrice.toString() : "");
    useEffect(() => setInputValue(maxOptionPrice), [maxOptionPrice])

    return (<>
        <TextField
            className={classes.root}
            value={inputValue}
            variant="outlined"
            size="small"
            style={{backgroundColor: "white", width: "100%"}}
            onChange={ev => setInputValue(ev.target.value.toString())}
            onBlur={ev => setMaxOptionPrice(parseFloat(ev.target.value !== undefined && !isNaN(parseFloat(ev.target.value)) ?
                ev.target.value : 0))}
            label={<Typography style={{fontSize: 10}}>Max Option Price</Typography>}
        ><Typography style={{fontSize: 1}}>{inputValue}</Typography></TextField>
    </>);
}